.menu {
  position: fixed;
  z-index: 80;
  min-width: 210px;
  padding: 4px 0;
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
  font-size: 0.9375rem;
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  min-height: 36px;
  padding: 0 14px;
  text-align: left;
  font: inherit;
  color: var(--text-primary);
  background: transparent;
  border: 0;
  cursor: pointer;
}

.item:hover:not(:disabled),
.item:focus-visible {
  background: var(--bg-secondary);
}

.item:disabled {
  color: var(--text-muted);
  cursor: default;
}

.danger {
  color: var(--status-busy);
}

.sep {
  height: 1px;
  margin: 4px 0;
  background: var(--border-subtle);
}

.heading {
  padding: 6px 14px 2px;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.sub {
  position: absolute;
  top: -5px;
  left: 100%;
  min-width: 260px;
  max-height: 70vh;
  overflow-y: auto;
  padding: 4px 0;
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
}

.subLeft {
  left: auto;
  right: 100%;
}

.hint {
  font-size: 0.75rem;
  color: var(--text-muted);
}
